"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _App["default"];
  }
});
var _App = _interopRequireDefault(require("./component/App"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }